/** Dimensions declared in pixels because Next Image / JS don't support rem */

// Largest size (on a mobile device)
export const CARD_LIST_THUMBNAIL_MAX_WIDTH = 400
// Largest size (on a mobile device)
export const LARGE_CARD_LIST_THUMBNAIL_MAX_WIDTH = 720
// Fixed size across all devices/viewport widths
export const TRACK_ROW_THUMBNAIL_WIDTH = 56
// Maximum width of any hero image
export const HERO_IMAGE_WIDTH = 2504
